module.exports = __webpack_public_path__ + "static/media/35_tn.767dfa50.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/thumbnails/35_tn.jpg
// module id = 344
// module chunks = 0